import React from 'react'
import Header from '../../Component/Header'
import AboutUs from '../AboutUs'
import Footer from '../../Component/Footer'

export default function LayoutAboutUs() {
  return (
    <>
      <Header/>
      <AboutUs/>
      <Footer/>
    </>
  )
}
